import { CartItem } from '../cart/cart-item';
export class OrderConfirmationInfo {
    cartItems: CartItem[];
    total_before_tax: number;
    total_after_tax: number;
    sales_tax: number;
    shipping_cost: number;
    grand_total: number;
}

function OrderConfirmationInfo_tsickle_Closure_declarations() {
/** @type {?} */
OrderConfirmationInfo.prototype.cartItems;
/** @type {?} */
OrderConfirmationInfo.prototype.total_before_tax;
/** @type {?} */
OrderConfirmationInfo.prototype.total_after_tax;
/** @type {?} */
OrderConfirmationInfo.prototype.sales_tax;
/** @type {?} */
OrderConfirmationInfo.prototype.shipping_cost;
/** @type {?} */
OrderConfirmationInfo.prototype.grand_total;
}
